module.exports = __webpack_public_path__ + "img/4.a9687465.jpg";